<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          :title="$t('foods.indicatorDetails')"
        >
          <b-form
            ref="foodindicatorform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="4"
                offset-md="4"
              >
                <b-row>

                  <b-col md="12">
                    <b-form-group
                      :label="$t('foods.indicator')"
                      label-for="FoodIndicatorId"
                    >
                      <z-food
                        v-model="Form.FoodIndicatorId"
                        :disabled="disabled"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      :label="$t('foods.foods')"
                      label-for="FoodIds"
                    >
                      <z-food
                        v-model="Form.FoodIds"
                        :multiple="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      :label="$t('common.description')"
                      label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-textarea
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          autocomplete="off"
                          rows="2"
                          no-resize
                        />
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      {{ $t('common.save') }}
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      {{ $t('common.back') }}
                    </b-button>
                  </b-col>

                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZFood from '@/tools/food.vue'

export default {
  name: 'FoodIndicatorDetails',
  components: {
    ZFood,
  },
  data() {
    return {
      Form: {
        FoodIndicatorId: null,
        FoodIds: [],
        Description: null,
      },
      loading: false,
      disabled: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.FoodIndicatorId = this.$route.params.id
      this.disabled = true
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.foodindicator.add
      if (this.$route.params.id) {
        url = this.$api.foodindicator.update
      }

      this.loading = true
      this.$http.post(
        url, this.Form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.foodindicator.get, {
          FoodIndicatorId: this.Form.FoodIndicatorId,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
